import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Badge } from "@mui/material";

import BarekamButton, { HeaderButtons } from '../../../components/button';
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import bell from "../../../../assets/icons/bell.svg";
import { getNotificationsCount } from "../../../../redux/slices/user-notifications.slice";

const NotificationsButton = ({ isDesktop }: NotificationsButtonProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isReady, setIsReady] = useState<boolean>(false);

    const { notificationsCount } = useAppSelector(state => state.userNotificationsReducer);

    useEffect(() => {
        dispatch(getNotificationsCount(false))
            .then(() => setIsReady(true));
    }, [dispatch]);

    if (isReady) {
        return (
            <BarekamButton type={HeaderButtons.SIMPLE}
                onClick={() => navigate('user/notifications')}
                key={'notifications-button'}>
                <Badge badgeContent={notificationsCount} color={'error'}>
                    <img src={bell}
                        alt={""} />
                </Badge>
            </BarekamButton>
        );
    }
    return (<></>);
};

interface NotificationsButtonProps {
    isDesktop: boolean
}

export default NotificationsButton;
